import {Doughnut} from 'vue-chartjs'
import { mapState } from "vuex";

export default Doughnut.extend({
  props: ['banks'],
  mounted () {
    let data = [];
    let labels = [];
    let banks = [];
    let backgroundColors = [];
    let colors = {
      tbank: '#FFDD2D',
      sber: '#24B23E',
      akbars: '#009b3a',
      alfa: '#ef3124',
      atb: '#fe5000',
      bbr: '#13317E',
      dvb: '#115740',
      finam: '#ffc759',
      gazprom: '#476bf0',
      ingos: '#004DE5',
      loko: '#1E60FC',
      mts: '#E30611',
      open: '#19aede',
      otp: '#000',
      ozon: '#0050e0',
      pochta: '#011689',
      psb: '#e86630',
      raif: '#FEE600',
      rosbank: '#000c1a',
      rshb: '#279429',
      russt: '#333',
      sberbyn: '#28a745',
      sovcom: '#003791',
      tochka: '#7f42e1',
      uralsib: '#3b175c',
      vtb: '#325AEC',
      wb: '#a50e8b',
      yandex: '#ff5b5b',
      vologjan: '#00a54f',
      vbrr: '#f2b600',
      uzum: '#7000ff',
      unicredit: '#cf3524',
      ubrir: '#a81235',
      solidar: '#dc3545',
      sngb: '#004182',
      sinara: '#dc0533',
      severgaz: '#4c9bd2',
      sdm: '#012B5D',
      rostfin: '#00c09f',
      rossia: '#003D5F',
      rnkb: '#02b8d3',
      pskb: '#46d200',
      poidem: '#c11f3e',
      novicom: '#55246A',
      modul: '#2042ab',
      mobicash: '#00499a',
      mkb: '#c31639',
      mirpriv: '#157915',
      mbank: '#0092a1',
      kuban: '#192ca9',
      kber: '#94c22b ',
      icb: '#B5020F',
      ibp: '#e46e24',
      genbank: '#30a027',
      fora: '#e92415',
      energo: '#0000f0',
      elpat: '#EF7C00',
      domrf: '#252628',
      cural: '#0057b6',
      creditevro: '#2e3192',
      cmr: '#0081c8',
      cinvest: '#50b848',
      cifra: '#01cb51',
      chermor: '#39BA9B',
      chelyab: '#b02f2f',
      chbrr: '#044cab',
      bystro: '#ffc27e ',
      bspb: '#1a202c',
      bks: '#007aff',
      avangard: '#0a653a',
      amra: '#ffbd4f',
    };
    if (this.banks.banks){
      Object.keys(this.banks.banks).forEach(item => {
        backgroundColors.push(colors[this.banks.banks[item].bank] || getRandomColor());
        data.push(this.banks.banks[item].count);
        labels.push(this.banks.banks[item].bank);
      });
      this.renderChart({
        labels: labels,
        datasets: [
          {
            backgroundColor: backgroundColors,
            data: data
          }
        ]
      }, {responsive: true, maintainAspectRatio: false})
    }
  }
})

function getRandomColor() {
  var letters = '0123456789ABCDEF';
  var color = '#';
  for (var i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
}


// WEBPACK FOOTER //
// ./src/components/chart/DoughnutBanks.js